import { checkPermission } from '@app/common/utils/helpers'

/**
 * Hook to check if the current user has permission to approve conversation messages
 * @returns {boolean} True if user has permission to approve conversation messages, false otherwise
 */
export const useConversationApprovalPermission = () => {
  try {
    return checkPermission('approve_conversation_messages')
  } catch {
    return false
  }
}
